import {LayerController} from './layer.controller';
import {Layer} from '../../shared/models/layer.model';
import {Page} from '../../shared/models/page.model';
import {Injector} from '@angular/core';
import {Marker} from '../../shared/models/map/marker.model';
import {EntityRepresentation} from '../../shared/models/visualization/representation.model';
import {TcddLayerService} from '../services/data/tcdd-layer.service';
import {NGSIResult} from '../../shared/models/ngsi/ngsi-result';

export class TcddTrainStationLayerController extends LayerController {
  displaysTooltip: boolean = true;
  constructor(layer: Layer, page: Page, private injector: Injector) {
    super(layer, page, injector);
  }

  protected getDialogContext(result: NGSIResult): any {
  }


  createTooltip(marker: Marker): string {
    const name = marker.entity.getSingleElementValue('name');


    let html = '<div class="entity-tooltip">';
    html += `<div class="text"> ${name} </div>`;
    html += '</div>';

    return html;
  }

}
